import Geocode from 'react-geocode';

export type LocationCoordinates = {
  lat: number;
  lng: number;
};
export const getLocationsCoordinatesFromAddress = async (
  address: string,
): Promise<LocationCoordinates> => {
  try {
    const fromAddress = await Geocode.fromAddress(address);
    const { lat, lng } = fromAddress.results[0].geometry.location;
    return { lat: Number(lat), lng: Number(lng) };
  } catch (err) {
    console.error('get lat and lng error - ', err);
    return { lat: null, lng: null };
  }
};

/**
 * Gets the address text from a given coordinates
 * @param lat latitude value
 * @param lng longitude value
 * @param givenAddress address to match from
 * @returns A matched address or the first finding incase none could be matched
 */
export const getAddressFromCoordinates = async (
  lat: number,
  lng: number,
  givenAddress: string,
): Promise<string | null> => {
  try {
    const fromLatLng = await Geocode.fromLatLng(lat.toString(), lng.toString());

    //find the given address from the geo list
    if (givenAddress && givenAddress != '') {
      const allAddress = fromLatLng.results.map(result => result.formatted_address);
      const found = allAddress.find(
        address => givenAddress.toLowerCase() === address.toLowerCase(),
      );
      if (found) return found; //if address match return the matched address
    }

    //no matching was found - return the first address
    const address = fromLatLng.results[0].formatted_address;

    return address;
  } catch (err) {
    return null;
  }
};

export const getStateFromCoordinates = (
  address: string,
): { city: string; state: string; statesShow: string } => {
  // const address = await getAddressFromCoordinates(lat, lng);
  const addressArr = address.split(',').map(item => item.replace(' ', ''));
  const { length } = addressArr;
  const city = length === 3 ? addressArr[length - 2] : addressArr[length - 3];
  const state = addressArr[length - 1];
  const country = length === 4 && addressArr[length - 2].substring(0, 2);
  let statesShow =
    length === 3 ? state : country ? `${city}, ${country}, ${state}` : `${city}, ${state}`;
  return { city, state, statesShow };
};
